const projects = [
    {
        title: "Activity Tracker",
        link: "https://activity-tracker-tau.vercel.app/",
        image: "./images/projects/activity_tracker.png",
        github_link: "https://github.com/sanbal13/activity-tracker",
        type: "react",
        status: 'Completed'
    },
    {
        title: "Calculator",
        link: "https://calculator-swart-seven.vercel.app/",
        image: "./images/projects/calculator.png",
        github_link: "https://github.com/sanbal13/Calculator",
        type: "hobby",
        status: 'Work in progress'
    },
    {
        title: "Logic Games",
        link: "https://logic-games.vercel.app/",
        image: "./images/projects/logic_games.png" ,
        github_link: "https://github.com/sanbal13/Logic-Games",
        type: 'hobby',
        status: 'Work in Progress'
    },
    {      
        title: "Restaurant",
        link: "https://restaurant-tau-three.vercel.app/",
        image: "./images/projects/happy_tummy.webp" ,
        github_link: "https://github.com/sanbal13/Restaurant",
        type: 'hobby',
        status: 'Work in Progress'
    },
    {
        title: "Bank",
        link: "https://currency-bank.vercel.app/",
        image: "./images/projects/currency_bank.webp" ,
        github_link: "https://github.com/sanbal13/Currency-Bank",
        type: 'hobby',
        status: 'Work in Progress'
    },
    {
        title: "Quiz",
        link: "https://capital-quiz-game.vercel.app/",
        image: "./images/projects/capital_quiz.webp" ,
        github_link: "https://github.com/sanbal13/Capital-Quiz-Game",
        type: 'hobby',
        status: 'Work in Progress'
    },
    {
        title: "Hospital",
        link: "https://we-care-delta.vercel.app/",
        image: "./images/projects/we-care.png" ,
        github_link: "https://github.com/sanbal13/WeCare",
        type: 'hobby',
        status: 'Work in Progress'
    },
    {
        title: "Buson",
        link: "https://buson-gamma.vercel.app/",
        image: "./images/projects/buson.webp" ,
        github_link: "https://github.com/sanbal13/buson",
        type: 'html',
        status: 'Completed'
    },
    {
        title: "Movie App",
        link: "https://ta-frontend-why-react-t-raaaa.vercel.app/",
        image: "./images/projects/movie.webp" ,
        github_link: "https://github.com/sanbal13/TA-FRONTEND-why-react-TRaaaa/tree/block-BRaaaa/block-BRaaaa/code",
        type: 'javascript',
        status: 'Completed'
    },
];
export default projects;